var _metadata, _defs, _clipPath, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorseCodeComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg121",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    stroke: "none",
    fill: "none",
    viewBox: "0.0 0.0 348.0 348.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata127"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs125"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    clipRule: "nonzero",
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g111",
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fillRule: "evenodd",
    d: "M 0,0 H 348 V 348 H 0 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fillRule: "evenodd",
    d: "M -6,0 H 342 V 347.9685 H -6 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fillRule: "evenodd",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fillRule: "evenodd",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "evenodd",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fillRule: "evenodd",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fillRule: "evenodd",
    d: "m 117.83202,290.61154 h 87.90551 v 34.80316 h -87.90551 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fillRule: "evenodd",
    d: "m 117.83202,290.61154 h 87.90551 v 34.80316 h -87.90551 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fillRule: "evenodd",
    d: "M 16.482939,118.44095 H 319.3176 v 157.5433 H 16.482939 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "evenodd",
    d: "M 16.482939,118.44095 H 319.3176 v 157.5433 H 16.482939 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fillRule: "evenodd",
    d: "m 58.66142,187.43045 h 218.67717 v 72.03149 H 58.66142 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fillRule: "evenodd",
    d: "M 48.307087,196.76903 25.440945,223.4462 48.307087,250.12337 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fillRule: "evenodd",
    d: "M 48.307087,196.76903 25.440945,223.4462 48.307087,250.12337 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fillRule: "evenodd",
    d: "m 287.6929,196.76903 22.86615,26.67717 -22.86615,26.67717 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fillRule: "evenodd",
    d: "m 287.6929,196.76903 22.86615,26.67717 -22.86615,26.67717 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fillRule: "evenodd",
    d: "m 161.49081,49.87664 113.82678,0.566929",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "evenodd",
    d: "m 161.49081,49.87664 113.82678,0.566929",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fillRule: "evenodd",
    d: "M 29.713911,49.87664 5.115486,5.97113",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fillRule: "evenodd",
    d: "M 29.713911,49.87664 5.115486,5.97113",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fillRule: "evenodd",
    d: "M 45.790028,23.199474 H 58.671917 V 76.55381 H 45.790028 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fillRule: "evenodd",
    d: "M 45.790028,23.199474 H 58.671917 V 76.55381 H 45.790028 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fillRule: "evenodd",
    d: "m 132.35695,23.199474 h 12.8819 V 76.55381 h -12.8819 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fillRule: "evenodd",
    d: "m 132.35695,23.199474 h 12.8819 V 76.55381 h -12.8819 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fillRule: "evenodd",
    d: "m 43.34646,139.81102 h 252.75589 v 30.33072 H 43.34646 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fillRule: "evenodd",
    d: "m 43.34646,139.81102 h 252.75589 v 30.33072 H 43.34646 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fillRule: "evenodd",
    d: "m 59.220474,170.94751 v -9.76378",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fillRule: "evenodd",
    d: "m 59.220474,170.94751 v -9.76378",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fillRule: "evenodd",
    d: "m 84.05541,139.81102 v 12.81891",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    fillRule: "evenodd",
    d: "m 84.05541,139.81102 v 12.81891",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    fillRule: "evenodd",
    d: "m 133.72528,139.40814 v 12.81889",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    fillRule: "evenodd",
    d: "m 133.72528,139.40814 v 12.81889",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    fillRule: "evenodd",
    d: "m 108.89035,170.54462 v -9.76378",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fillRule: "evenodd",
    d: "m 108.89035,170.54462 v -9.76378",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    fillRule: "evenodd",
    d: "m 233.06505,139.40683 v 12.81889",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    fillRule: "evenodd",
    d: "m 233.06505,139.40683 v 12.81889",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    fillRule: "evenodd",
    d: "m 208.23009,170.5433 v -9.76378",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    fillRule: "evenodd",
    d: "m 208.23009,170.5433 v -9.76378",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    fillRule: "evenodd",
    d: "m 282.7349,139.40683 v 12.81889",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    fillRule: "evenodd",
    d: "m 282.7349,139.40683 v 12.81889",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    fillRule: "evenodd",
    d: "m 257.89996,170.5433 v -9.76378",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    fillRule: "evenodd",
    d: "m 257.89996,170.5433 v -9.76378",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    fillRule: "evenodd",
    d: "m 158.56023,170.54462 v -9.76378",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    fillRule: "evenodd",
    d: "m 158.56023,170.54462 v -9.76378",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    fillRule: "evenodd",
    d: "m 183.39516,139.40814 v 12.81889",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    fillRule: "evenodd",
    d: "m 183.39516,139.40814 v 12.81889",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    fillRule: "evenodd",
    d: "m 64.10499,136.14699 h 8.535431 v 40.28346 H 64.10499 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    fillRule: "evenodd",
    d: "m 64.10499,136.14699 h 8.535431 v 40.28346 H 64.10499 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    fillRule: "evenodd",
    d: "m 56.43307,30.55643 h 75.937 v 40.283466 h -75.937 z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    fillRule: "evenodd",
    d: "m 56.43307,30.55643 h 75.937 v 40.283466 h -75.937 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    fillRule: "evenodd",
    d: "m 145.23885,34.711285 h 8.12598 v 0 c 4.48787,0 8.12599,6.789761 8.12599,15.165356 0,8.375595 -3.63812,15.165352 -8.12599,15.165352 h -8.12598 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    fillRule: "evenodd",
    d: "m 145.23885,34.711285 h 8.12598 v 0 c 4.48787,0 8.12599,6.789761 8.12599,15.165356 0,8.375595 -3.63812,15.165352 -8.12599,15.165352 h -8.12598 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    fillRule: "evenodd",
    d: "m 45,65.04199 h -8.125984 v 0 c -4.487858,0 -8.125984,-6.789757 -8.125984,-15.165352 0,-8.375595 3.638126,-15.165356 8.125984,-15.165356 H 45 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    fillRule: "evenodd",
    d: "m 45,65.04199 h -8.125984 v 0 c -4.487858,0 -8.125984,-6.789757 -8.125984,-15.165352 0,-8.375595 3.638126,-15.165356 8.125984,-15.165356 H 45 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 36,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#ffffff"
    },
    id: "text115",
    "aria-label": "3.500 MHz"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m 85.771484,222.84961 q 2.548828,0.54492 3.972657,2.26758 1.441406,1.72265 1.441406,4.2539 0,3.88477 -2.671875,6.01172 -2.671875,2.12696 -7.59375,2.12696 -1.652344,0 -3.410156,-0.33399 -1.740235,-0.31641 -3.603516,-0.9668 v -3.42773 q 1.476562,0.86133 3.234375,1.30078 1.757812,0.43945 3.673828,0.43945 3.339844,0 5.080078,-1.31836 1.757813,-1.31835 1.757813,-3.83203 0,-2.32031 -1.634766,-3.62109 Q 84.400391,224.43164 81.5,224.43164 h -3.058594 v -2.91797 h 3.199219 q 2.619141,0 4.007812,-1.03711 1.388672,-1.05469 1.388672,-3.02344 0,-2.02148 -1.441406,-3.09375 -1.423828,-1.08984 -4.095703,-1.08984 -1.458984,0 -3.128906,0.31641 -1.669922,0.3164 -3.673828,0.98437 v -3.16406 q 2.021484,-0.5625 3.779296,-0.84375 1.775391,-0.28125 3.339844,-0.28125 4.042969,0 6.398438,1.8457 2.355468,1.82813 2.355468,4.95703 0,2.17969 -1.248046,3.69141 -1.248047,1.49414 -3.550782,2.07422 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "m 97.935547,232.53516 h 3.708983 V 237 h -3.708983 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 109.43164,210.75586 h 13.93945 v 2.98828 h -10.6875 v 6.43359 q 0.77344,-0.26367 1.54688,-0.38671 0.77344,-0.14063 1.54687,-0.14063 4.39454,0 6.96094,2.4082 2.56641,2.40821 2.56641,6.52149 0,4.23633 -2.63672,6.59179 -2.63672,2.3379 -7.43555,2.3379 -1.65234,0 -3.375,-0.28125 -1.70508,-0.28125 -3.5332,-0.84375 v -3.56836 q 1.58203,0.86132 3.26953,1.2832 1.6875,0.42187 3.56836,0.42187 3.04102,0 4.81641,-1.59961 1.77539,-1.5996 1.77539,-4.34179 0,-2.74219 -1.77539,-4.3418 -1.77539,-1.59961 -4.81641,-1.59961 -1.42383,0 -2.84766,0.31641 -1.40625,0.3164 -2.88281,0.98437 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 139.91211,213.09375 q -2.74219,0 -4.13086,2.70703 -1.37109,2.68945 -1.37109,8.10352 0,5.39648 1.37109,8.10351 1.38867,2.68946 4.13086,2.68946 2.75976,0 4.13086,-2.68946 1.38867,-2.70703 1.38867,-8.10351 0,-5.41407 -1.38867,-8.10352 -1.3711,-2.70703 -4.13086,-2.70703 z m 0,-2.8125 q 4.41211,0 6.73242,3.49805 2.33789,3.48047 2.33789,10.125 0,6.62695 -2.33789,10.125 -2.32031,3.48047 -6.73242,3.48047 -4.41211,0 -6.75,-3.48047 -2.32031,-3.49805 -2.32031,-10.125 0,-6.64453 2.32031,-10.125 2.33789,-3.49805 6.75,-3.49805 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "m 162.83398,213.09375 q -2.74218,0 -4.13086,2.70703 -1.37109,2.68945 -1.37109,8.10352 0,5.39648 1.37109,8.10351 1.38868,2.68946 4.13086,2.68946 2.75977,0 4.13086,-2.68946 1.38868,-2.70703 1.38868,-8.10351 0,-5.41407 -1.38868,-8.10352 -1.37109,-2.70703 -4.13086,-2.70703 z m 0,-2.8125 q 4.41211,0 6.73243,3.49805 2.33789,3.48047 2.33789,10.125 0,6.62695 -2.33789,10.125 -2.32032,3.48047 -6.73243,3.48047 -4.41211,0 -6.75,-3.48047 -2.32031,-3.49805 -2.32031,-10.125 0,-6.64453 2.32031,-10.125 2.33789,-3.49805 6.75,-3.49805 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "m 189.30664,210.75586 h 5.29102 l 6.69726,17.85937 6.73242,-17.85937 h 5.29102 V 237 h -3.46289 v -23.04492 l -6.76758,18 h -3.56836 l -6.76758,-18 V 237 h -3.44531 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path141",
    d: "m 220.38477,210.75586 h 3.55078 v 10.75781 h 12.90234 v -10.75781 h 3.55078 V 237 h -3.55078 V 224.50195 H 223.93555 V 237 h -3.55078 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path143",
    d: "m 245.9082,217.3125 h 15.36328 v 2.95312 l -12.16406,14.1504 h 12.16406 V 237 h -15.80273 v -2.95313 l 12.16406,-14.15039 H 245.9082 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text119",
    "aria-label": "TX"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "m 148.97266,300.41992 h 12.33398 v 1.66016 h -5.17578 V 315 h -1.98242 v -12.91992 h -5.17578 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "m 162.51758,300.41992 h 2.11914 l 3.62305,5.41992 3.64257,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 168.11328,308.79883 163.98242,315 h -2.1289 l 5.20507,-7.7832 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorseCodeComponent);
export default __webpack_public_path__ + "static/media/MorseCodeComponent.b719cb05609043cde3a9171da3e5f50e.svg";
export { ForwardRef as ReactComponent };